(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AlcoholController', AlcoholController);

    AlcoholController.$inject = ['$uibModalInstance', 'Alcohol', 'chart', '$q', 'DTColumnBuilder', 'DTOptionsBuilder',
        '$compile', '$scope', '$rootScope', '$uibModal', 'ConfirmationService', '$uibModalStack'];

    function AlcoholController($uibModalInstance, Alcohol, chart, $q, DTColumnBuilder, DTOptionsBuilder,
                               $compile, $scope, $rootScope, $uibModal, ConfirmationService, $uibModalStack) {
        var vm = this;

        vm.chart = chart;
        vm.alcohol = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.clear = clear;
        vm.search = search;
        vm.edit = edit;
        vm.del = del;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Alcohol.byChart({chartId: vm.chart.id, page: vm.page - 1, size: vm.itemsPerPage}, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.alcohol = result;
                defer.resolve(vm.alcohol);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notVisible().renderWith(function (data, type, full) {
                return data ? moment(data.date).format("YYYYMMDD") : "";
            }),
            DTColumnBuilder.newColumn('date').withTitle('Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Value').renderWith(function (data, type, full) {
                return data.value ? data.value : " - ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Notes').renderWith(function (data, type, full) {
                return data.description ? data.description : " - ";
            }),
            DTColumnBuilder.newColumn('createdBy').withTitle('Created By'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.chart.status) {
                stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }


        function search() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function edit(id) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/alcohol/update/alcohol-dialog.html',
                controller: 'AlcoholDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['Alcohol', function (Alcohol) {
                        return Alcohol.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Alcohol').result.then(function () {
                Alcohol.delete({id: id}, function () {
                    search();
                });
            })
        }
    }
})();
